export default __webpack_public_path__ + "static/media/logo.b4af9b79.svg";